module.exports = __webpack_public_path__ + "static/media/target_lv_61b5399b2d0bd01f8ee29bf25602067fc.webp";